import Layout from '@/layout/layout'

const featureRouter = {
  path: '/storeManage',
  component: Layout,
  redirect: 'noRedirect',
  name: '门店管理',
  children: [
    {
      path: 'index',
      component: () => import('@/views/storeManage/Administration/index'),
      name: '门店列表',
      meta: { title: '门店列表', noCache: true, fixed: true }
    }, {
      path: 'region',
      component: () => import('@/views/storeManage/region/index'),
      name: '区域管理',
      meta: { title: '区域管理', noCache: true, fixed: true }
    }, {
      path: 'storeTag',
      component: () => import('@/views/storeManage/storeTag/index'),
      name: '门店标签管理',
      meta: { title: '门店标签管理', noCache: true, fixed: true }
    }, {
      path: 'collectionBlacklist',
      component: () => import('@/views/storeManage/collectionBlacklist/index'),
      name: '收款黑名单',
      meta: { title: '收款黑名单', noCache: true, fixed: true }
    },
  ]
}

export default featureRouter
